import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';

import { KeyValueModel } from '@models/common';
import { ListResponse } from '@models/helpers';
import { HttpService } from '@shared/services';

import { AdjustmentModel, AdjustmentReleaseModel, AdjustmentRequest } from './api-models/adjustments.model';

@Injectable({
  providedIn: 'root',
})
export class AdjustmentsService {
  private http = inject(HttpService);

  searchAdjustments(entityInstanceId: number) {
    const params = this.http.buildHttpParams({ entityInstanceId });
    return this.http
      .post<ListResponse<AdjustmentModel>>(
        '_api/Adjustments/Search',
        {},
        {
          httpOptions: { params },
          useLoader: false,
        },
      )
      .pipe(map(response => response?.data ?? []));
  }

  createAdjustment(entityInstanceId: number, adjustment: AdjustmentRequest) {
    const params = this.http.buildHttpParams({ entityInstanceId });
    return this.http.post<number>('_api/Adjustments/Create', adjustment, {
      httpOptions: { params },
      useLoader: false,
    });
  }

  updateAdjustment(entityInstanceId: number, adjustment: AdjustmentRequest) {
    const params = this.http.buildHttpParams({ entityInstanceId });
    return this.http.put<void>('_api/Adjustments/Update', adjustment, {
      httpOptions: { params },
      useLoader: false,
    });
  }

  deleteAdjustment(entityInstanceId: number, id: number) {
    const params = this.http.buildHttpParams({ id, entityInstanceId });
    return this.http.put<void>('_api/Adjustments/Delete', null, {
      httpOptions: { params },
      useLoader: false,
    });
  }

  closeAdjustment(contractId: number, id: number) {
    const params = this.http.buildHttpParams({ id, contractId });
    return this.http.put<void>('_api/Adjustments/CloseAdjustment', null, {
      httpOptions: { params },
      useLoader: false,
    });
  }

  getReleases(entityInstanceId: number, adjustmentId: number) {
    const params = this.http.buildHttpParams({ adjustmentId, entityInstanceId });
    return this.http.get<AdjustmentReleaseModel[]>('_api/Adjustments/Releases', {
      httpOptions: { params },
      useLoader: false,
    });
  }

  createRelease(entityInstanceId: number, release: AdjustmentReleaseModel) {
    const params = this.http.buildHttpParams({ entityInstanceId });
    return this.http.post<number>('_api/Adjustments/CreateRelease', release, {
      httpOptions: { params },
      useLoader: false,
    });
  }

  updateRelease(entityInstanceId: number, release: AdjustmentReleaseModel) {
    const params = this.http.buildHttpParams({ entityInstanceId });
    return this.http.put<void>('_api/Adjustments/UpdateRelease', release, {
      httpOptions: { params },
      useLoader: false,
    });
  }

  deleteRelease(entityInstanceId: number, id: number) {
    const params = this.http.buildHttpParams({ id, entityInstanceId });
    return this.http.put<void>('_api/Adjustments/DeleteRelease', null, {
      httpOptions: { params },
      useLoader: false,
    });
  }

  getCategories() {
    return this.http.get<KeyValueModel<number, string>[]>('_api/Adjustments/CategoryDict', {
      useLoader: false,
    });
  }

  getAccrualFrequencies() {
    return this.http.get<KeyValueModel<number, string>[]>('_api/Adjustments/AccrualFrequencyDict', {
      useLoader: false,
    });
  }
}
